export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/excel.32da1c4.svg";